import { Controller } from "@hotwired/stimulus"

// Handles live inputs panel interactivity
// Provides optimistic UI updates for snappy feel
export default class extends Controller {
  static values = {
    strategyUuid: String
  }

  connect() {
    // Controller ready
  }

  // Optimistic delete - fade out immediately, server syncs in background
  deleteInput(event) {
    const inputContainer = event.target.closest('[data-input-container]')
    if (inputContainer) {
      inputContainer.style.transition = 'opacity 0.15s ease-out, transform 0.15s ease-out'
      inputContainer.style.opacity = '0'
      inputContainer.style.transform = 'translateX(-10px)'
      inputContainer.style.pointerEvents = 'none'
    }
  }

  // Stance selection is deliberately NOT painted optimistically.
  //
  // It used to be, and the two sources drifted: this added accent blue while the
  // server renders the stance semantically (Bullish green / Neutral cream /
  // Bearish red via live_input_stance_class). It also only removed the accent
  // classes, never the server's, so after one click the DOM held both
  // bg-[--color-kova-cream]/15 and bg-white/5 on the same button and two options
  // could look active at once, in the wrong colours.
  //
  // The PATCH replaces the whole live_inputs_panel turbo-frame, so the server is
  // the single source of truth and the round trip is fast enough not to need a
  // stand-in. Re-adding optimistic paint means re-deriving every stance class
  // here and keeping it in step with the helper — don't.
}

